import { render } from "./EnterPhonePage.vue?vue&type=template&id=15564377&scoped=true"
import script from "./EnterPhonePage.vue?vue&type=script&lang=js"
export * from "./EnterPhonePage.vue?vue&type=script&lang=js"

import "./EnterPhonePage.vue?vue&type=style&index=0&id=15564377&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15564377"]])

export default __exports__